import styled from "styled-components";
import { ICON_SIZES } from "src/apps/components/icon/Icon";
import { TextContent } from "src/apps/components/typography/Texts";

import { colors } from "@permisso/permisso-components";

export const IconContainer = styled.div`
  min-height: ${ICON_SIZES.s18}rem;
  min-width: ${ICON_SIZES.s18}rem;
  padding-top: 0.125rem;
  margin-left: 0.125rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const InfoText = styled(TextContent)`
  color: ${colors.grey700};
`;
